
/**
 * The default display plugin
 */
(function(factory){'use strict'; if (typeof CustomTC.define === 'function' && CustomTC.define.amd) {CustomTC.define('tooltipster/js/jquery.tooltipster.display',['modules/core-library'], factory);} else {factory(jQuery);}}(function($) {
	
	var pluginName = 'default',
		/** 
		 * @param {object} tooltipster The tooltipster instance that instantiated this plugin
		 * @param {object} options Options, @see self::defaults()
		 */
		plugin = function(tooltipster, options) {
			
			// list of instance variables
			
			this.options = $.extend(true, this.defaults(), options);
			this.tooltipster = tooltipster;
			
			// disable the arrow in IE6 unless the arrow option was explicitly set to true
			var $d = $('<i><!--[if IE 6]><i></i><![endif]--></i>');
			if (	$d.children().length > 0
				&&	options.arrow !== true
			) {
				this.options.arrow = false;
			}
			
			// initialize
			this.init(tooltipster, options);
		};
	
	plugin.prototype = {
		
		/**
		 * Defaults are provided as a function for an easy override by inheritance
		 * 
		 * @return {object} An object with the defaults options
		 */
		defaults: function() {
			
			return {
				// if the tooltip should display an arrow that points to the origin
				arrow: true,
				// the distance in pixels between the tooltip and the origin
				distance: 6,
				// allows to easily change the position of the tooltip
				functionPosition: null,
				maxWidth: null,
				minWidth: 0,
				position: ['top', 'bottom', 'right', 'left']
				/*
				// TODO: these rules let the user choose what to do when the tooltip content
				// overflows. Right now the order of fallbacks is fixed :
				// - we're looking for a spot where the natural size of the tooltip can fit
				//   ('window.switch')
				// - if can't find one, we check if setting a constrained width on the
				//   tooltip could solve the problem without having the content overflowing
				//   ('window.constrain')
				// - if it does not work, we let the tooltip overflow the window in its
				//   natural size, in the limits of the document ('document.switch')
				// - if it does not work, we see if a constrained width could make the
				//   tooltip fit in the document without its content overflowing
				//   ('document.constrain')
				// - and if that can't be done, we just let the tooltip in the preferred
				//   position with a natural size, overflowing the document
				//   ('document.overflow')
				positioningRules: [
					'window.switch',
					// or try to see if the tooltip could be displayed somewhere with a
					// constrained width without its content overflowing
					'window.constrain',
					// TODO : window.scroll should be a possible rule, rather than fall
					// back to overflowing in the rest of the document. The content would
					// have horizontal and/or vertical scrollbars but the tooltip would not
					// overflow the window. It would require to set a max-height on the
					// content div, etc.
					//'window.scroll',
					'document.switch',
					'document.constrain',
					// TODO - similar to 'window.scroll'
					//'document.scroll'
					'document.overflow'
				]
				*/
			};
		},
		
		/**
		 * Run once: at instantiation of the display plugin (when the tooltip is shown for
		 * the first time).
		 */
		init: function() {
			var defaults = this.defaults();
			
			// option formatting
			
			// format position as a four-cell array if it ain't one yet and then make it
			// an object with top/bottom/left/right properties
			if (typeof this.options.distance != 'object') {
				this.options.distance = [this.options.distance];
			}
			if (this.options.distance[1] === undefined) this.options.distance[1] = this.options.distance[0];
			if (this.options.distance[2] === undefined) this.options.distance[2] = this.options.distance[0];
			if (this.options.distance[3] === undefined) this.options.distance[3] = this.options.distance[1];
			this.options.distance = {
				top: this.options.distance[0],
				right: this.options.distance[1],
				bottom: this.options.distance[2],
				left: this.options.distance[3]
			};
			
			// let's transform 'top' into ['top', 'bottom', 'right', 'left'] (for example)
			if (typeof this.options.position == 'string') {
				this.options.position = [this.options.position];
				for (var i=0; i<4; i++) {
					if (this.options.position[0] != defaults.position[i]) {
						this.options.position.push(defaults.position[i]);
					}
				}
			}
		},
		
		/**
		 * Contains the HTML markup of the tooltip.
		 *
		 * @return {object} The tooltip, as a jQuery-wrapped HTML element
		 */
		build: function() {
			
			// note: we wrap with a .tooltipster-box div to be able to set a margin on it
			// (.tooltipster-base must not have one)
			var $html = $(
				'<div class="tooltipster-base">' +
					'<div class="tooltipster-box">' +
						'<div class="tooltipster-content"></div>' +
					'</div>' +
					'<div class="tooltipster-arrow">' +
						'<div class="tooltipster-arrow-uncropped">' +
							'<div class="tooltipster-arrow-border"></div>' +
							'<div class="tooltipster-arrow-background"></div>' +
						'</div>' +
					'</div>' +
				'</div>'
			);
			
			// hide arrow if asked
			if (!this.options.arrow) {
				$html
					.find('.tooltipster-box')
						.css('margin', 0)
						.end()
					.find('.tooltipster-arrow')
						.hide();
			}
			
			// apply min/max width if asked
			if (this.options.minWidth) {
				$html.css('min-width', this.options.minWidth + 'px');
			}
			if (this.options.maxWidth) {
				$html.css('max-width', this.options.maxWidth + 'px');
			}
			
			return $html;
		},
		
		/**
		 * Get or set options. Provided for advanced users.
		 * 
		 * @param {string} o Option name
		 * @param {mixed} val optional A new value for the option
		 * @return {mixed} If val is omitted, the value of the option is returned, otherwise
		 * the instance itself is returned
		 */
		option: function(o, val) {
			if (val === undefined) return this.options[o];
			else {
				this.options[o] = val;
				return this;
			}
		},
		
		/**
		 * Make whatever modifications are needed when the position is changed. This has
		 * been made an independant method for easy inheritance in custom plugins based
		 * on this default plugin.
		 */
		position_change: function(position) {
			
			this.tooltipster.$tooltip
				.removeClass('tooltipster-bottom')
				.removeClass('tooltipster-left')
				.removeClass('tooltipster-right')
				.removeClass('tooltipster-top')
				.addClass('tooltipster-' + position);
		},
		
		/**
		 * This method must compute and set the positioning properties of the tooltip
		 * (might be left, top, width, height, etc.). It must also make sure the
		 * tooltip is eventually appended to its parent (since the element may be
		 * detached from the DOM at the moment the method is called).
		 * 
		 * @param {object} $tooltip The jQuery-wrapped HTML root element of the tooltip
		 * @param {object} $parent The jQuery-wrapped HTML element that tooltip must be
		 * appended to at the end of the call
		 * @param {object} helper An object that contains variables that plugin
		 * creators may find useful (see below)
		 * @param {object} helper.geo An object with many properties (size, positioning)
		 * about objects of interest (window, document, origin). This should help plugin
		 * users to compute the optimal position of the tooltip
		 * @param {object} helper.tooltipster The Tooltipster instance which calls this
		 * method. Plugin creators will at least have to use tooltipster.$tooltip and
		 * tooltipster.$parent. Also, some of its methods may help plugin creators,
		 * especially its _sizer internal methods that help measure the size of the
		 * tooltip in various conditions.
		 */
		reposition: function(helper) {
			
			var self = this,
				finalResult,
				testResults = {
					document: {},
					window: {}
				};
			
			// start position tests session
			self.tooltipster._sizerStart();
			
			// find which position can contain the tooltip without overflow.
			// We'll compute things relatively to window, then document if need be.
			$.each(['window', 'document'], function(i, container) {
				
				var fits,
					constrainedFits = false,
					distance,
					naturalSize,
					outerNaturalSize,
					pos,
					sizerResult;
				
				for (var i=0; i < self.options.position.length; i++) {
					
					distance = {
						horizontal: 0,
						vertical: 0
					};
					pos = self.options.position[i];
					
					// this may have an effect on the size of the tooltip if there are css
					// rules for the arrow or something else
					self.position_change(pos);
					
					// now we get the size of the tooltip when it does not have any size
					// constraints set
					naturalSize = self.tooltipster._sizerNatural();
					
					if (pos == 'top' || pos == 'bottom') {
						distance.vertical = self.options.distance[pos];
					}
					else {
						distance.horizontal = self.options.distance[pos];
					}
					
					outerNaturalSize = {
						height: naturalSize.height + distance.vertical,
						width: naturalSize.width + distance.horizontal
					};
					
					testResults[container][pos] = {};
					
					// if the tooltip can fit without any adjustment
					fits = false;
					
					if (	helper.geo.available[container][pos].width >= outerNaturalSize.width
						&&	helper.geo.available[container][pos].height >= outerNaturalSize.height
					) {
						fits = true;
					}
					
					testResults[container][pos].natural = {
						fits: fits,
						distance: distance,
						outerSize: outerNaturalSize,
						position: pos,
						size: naturalSize,
						sizeMode: 'natural'
					};
					
					if (fits) {
						
						// we don't need to compute more positions, a natural one is fine
						return false;
					}
					else {
						
						// let's try to use size constraints to fit
						sizerResult = self.tooltipster._sizerConstrained(
							helper.geo.available[container][pos].width - distance.horizontal,
							helper.geo.available[container][pos].height - distance.vertical
						);
						
						testResults[container][pos].constrained = {
							fits: sizerResult.fits,
							distance: distance,
							outerSize: {
								height: sizerResult.size.height + distance.vertical,
								width: sizerResult.size.width + distance.horizontal
							},
							position: pos,
							size: sizerResult.size,
							sizeMode: 'constrained'
						};
						
						if (sizerResult.fits) {
							constrainedFits = true;
						}
					}
				}
				
				// if a constrained size fits, don't run tests against the document
				if (constrainedFits) {
					return false;
				}
			});
			
			
			// Based on test, pick the position we'll use.
			// TODO : let the user choose the order of the positioning rules
			$.each(['window', 'document'], function(i, container) {
				for (var i=0; i < self.options.position.length; i++) {
					
					var pos = self.options.position[i];
					
					$.each(['natural', 'constrained'], function(i, mode) {
						
						if (	testResults[container][pos][mode]
							&&	testResults[container][pos][mode].fits
						) {
							finalResult = testResults[container][pos][mode];
							return false;
						}
					});
					
					if (finalResult) {
						return false;
					}
				}
			});
			// if everything failed, this falls back on the preferred position but the
			// tooltip will overflow the document
			if (!finalResult) {
				finalResult = testResults.document[self.options.position[0]].natural;
			}
			
			// first, let's find the coordinates of the tooltip relatively to the window,
			// centering it on the middle of the origin
			finalResult.coord = {};
			
			switch (finalResult.position) {
				
				case 'left':
				case 'right':
					finalResult.coord.top = Math.floor(helper.geo.origin.windowOffset.top - (finalResult.size.height / 2) + (helper.geo.origin.size.height / 2));
					break;
				
				case 'bottom':
				case 'top':
					finalResult.coord.left = Math.floor(helper.geo.origin.windowOffset.left - (finalResult.size.width / 2) + (helper.geo.origin.size.width / 2));
					break;
			}
			
			switch (finalResult.position) {
				
				case 'left':
					finalResult.coord.left = helper.geo.origin.windowOffset.left - finalResult.outerSize.width;
					break;
				
				case 'right':
					finalResult.coord.left = helper.geo.origin.windowOffset.left + helper.geo.origin.size.width + finalResult.distance.horizontal;
					break;
				
				case 'top':
					finalResult.coord.top = helper.geo.origin.windowOffset.top - finalResult.outerSize.height;
					break;
				
				case 'bottom':
					finalResult.coord.top = helper.geo.origin.windowOffset.top + helper.geo.origin.size.height + finalResult.distance.vertical;
					break;
			}
			
			// then if the tooltip overflows the viewport, we'll move it accordingly (it will
			// not be centered on the middle of the origin anymore). We only move horizontally
			// for top and bottom tooltips and vice versa.
			if (finalResult.position == 'top' || finalResult.position == 'bottom') {
				
				// if there is an overflow on the left
				if (finalResult.coord.left < 0) {
					finalResult.coord.left = 0;
				}
				// or an overflow on the right
				else if (finalResult.coord.left + finalResult.size.width > helper.geo.window.size.width) {
					finalResult.coord.left += helper.geo.window.size.width - (finalResult.coord.left + finalResult.size.width);
				}
			}
			else {
				
				// overflow on top
				if (finalResult.coord.top < 0) {
					finalResult.coord.top = 0;
				}
				// or at bottom
				else if (finalResult.coord.top + finalResult.size.height > helper.geo.window.size.height) {
					finalResult.coord.top += helper.geo.window.size.height - (finalResult.coord.top + finalResult.size.height);
				}
			}
			
			// submit the positioning proposal to the user function which may choose to change
			// the position, size and/or the coordinates
			
			// first, set the rules that corresponds to the proposed position : it may change
			// the size of the tooltip, and the custom functionPosition may want to detect the
			// size of something before making a decision. So let's make things easier for the
			// implementor
			self.position_change(finalResult.position);
			
			// include the tooltip and parent in the helper for the custom function
			helper.$tooltip = self.tooltipster.$tooltip;
			helper.$parent = self.tooltipster.$parent;
			
			if(self.options.functionPosition){
				finalResult = self.options.functionPosition.call(self, helper, $.extend(true, {}, finalResult));
			}
			
			// now let's compute the position of the arrow
			if (finalResult.position == 'top' || finalResult.position == 'bottom') {
				
				var arrowCoord = {
					prop: 'left',
					val: helper.geo.origin.windowOffset.left + Math.floor(helper.geo.origin.size.width / 2) - finalResult.coord.left
				};
				
				if (arrowCoord.val < 0) {
					arrowCoord.val = 0;
				}
				else if (arrowCoord.val > finalResult.size.width) {
					arrowCoord.val = finalResult.size.width;
				}
			}
			else {
				
				var arrowCoord = {
					prop: 'top',
					val: helper.geo.origin.windowOffset.top + Math.floor(helper.geo.origin.size.height / 2) - finalResult.coord.top
				};
				
				if (arrowCoord.val < 0) {
					arrowCoord.val = 0;
				}
				else if (arrowCoord.val > finalResult.size.height) {
					arrowCoord.val = finalResult.size.height;
				}
			}
			
			var originParentOffset;
			
			// let's convert the window-relative coordinates into coordinates relative to the
			// future positioned parent that the tooltip will be appended to
			if (helper.geo.origin.fixedLineage) {
				
				// same as windowOffset when the position is fixed
				originParentOffset = helper.geo.origin.windowOffset;
			}
			else {
				
				if (self.tooltipster.$parent[0].tagName.toLowerCase() == 'body') {
					
					originParentOffset = {
						left: helper.geo.origin.windowOffset.left + helper.geo.window.scroll.left,
						top: helper.geo.origin.windowOffset.top + helper.geo.window.scroll.top
					};
				}
				else {
					// TODO. right now $parent cannot be something other than <body>.
					// when we do this, .tooltipster-sizer will have to be appended to the parent
					// to inherit css style values that affect the display of the text and such
				}
			}
			
			finalResult.coord = {
				left: originParentOffset.left + (finalResult.coord.left - helper.geo.origin.windowOffset.left),
				top: originParentOffset.top + (finalResult.coord.top - helper.geo.origin.windowOffset.top)
			};
			
			// set position values
			
			// again, in case functionPosition changed the position (left/right etc)
			self.position_change(finalResult.position);
			
			if (helper.geo.origin.fixedLineage) {
				self.tooltipster.$tooltip
					.css('position', 'fixed');
			}
			else {
				// CSS default
				self.tooltipster.$tooltip
					.css('position', '');
			}
			
			self.tooltipster.$tooltip
				.css({
					left: finalResult.coord.left,
					top: finalResult.coord.top
				})
				.find('.tooltipster-arrow')
					.css({
						'left': '',
						'top': ''
					})
					.css(arrowCoord.prop, arrowCoord.val);
			
			// we don't need to set a size if the size is natural. It would be harmless in Chrome
			// but it creates a bug in Firefox, so we just don't do it
			if (finalResult.sizeMode == 'constrained') {
				
				self.tooltipster.$tooltip
					.css({
						height: finalResult.size.height,
						width: finalResult.size.width
					});
			}
			else {
			
				self.tooltipster.$tooltip
					.css({
						height: '',
						width: ''
					});
			}
			
			// end position tests session and append the tooltip HTML element to its parent
			self.tooltipster._sizerEnd();
		}
	};
	
	$.tooltipster.displayPlugin[pluginName] = plugin;
	
}));
